import React, { useContext, useEffect, useState } from 'react';
import ModalButton from './ModalButton';
import useRemote from '../hooks/useRemote';
import { AppContext } from '../App';
import { formatISO } from 'date-fns';
import fileDownload from 'js-file-download';

const CreatingModal = ({file, closeModal})=>{

	const [ disabled, setDisabled ] = useState(true);
	const remote = useRemote();
	const app = useContext(AppContext);

	useEffect(()=>{
		file.arrayBuffer().then(data=>remote.getPDF(data)).then(pdf=>{
			const user = app.user;
			const filename = "Maths Homework Sheets - " + user.substring(0, user.indexOf("@")) + " - " + formatISO(new Date()).substring(0, 10) + ".pdf";
			fileDownload(pdf, filename)
		}).then(()=>{
			if (!app.school.mathsLicenseExpiry) {
				remote.refreshSchool().then(()=>setDisabled(false));
			} else {
				setDisabled(false);
			}
		});
	}, [ file, app.user ]);


	return <div>
		{disabled && <div>Your homework sheets are being created and will start to download shortly.  Please wait...</div>}
		{!disabled && <div>Your homework sheets have been created and should be available in your downloads folder.  Enjoy!</div>}
		<ModalButton text="Close" disabled={disabled} onClick={closeModal} />
	</div>
}

export default CreatingModal;